import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import CampaignsList from './CampaignsList';
import translate from 'components/hoc/translate';

const CampaignsListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.campaigns.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <CampaignsList
                { ...props }
            />
        </div>
    );
};

CampaignsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(CampaignsListContainer);



// WEBPACK FOOTER //
// ./src/pages/campaigns/list/CampaignsListContainer.js